// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jz-3";
export var downloadButton = "_jz-4";
export var fileContainer = "_jz-9 _jz-7";
export var fileContainerBase = "_jz-7";
export var fileContainerFixedHeight = "_jz-8 _jz-7";
export var fileInfo = "_jz-5";
export var fileInfoWidthRestricted = "_jz-6";
export var fileType = "_jz-1";
export var fileTypeName = "_jz-2";
export var image = "_jz-0";
export var link = "_jz-b";
export var overflowEllipsis = "_jz-a";